export default __webpack_public_path__ + "static/media/additionalInfoIcon.8e3b828b.svg";